import { render } from "./UserAlimentazione.vue?vue&type=template&id=68667edc&scoped=true"
import script from "./UserAlimentazione.vue?vue&type=script&lang=js"
export * from "./UserAlimentazione.vue?vue&type=script&lang=js"

import "./UserAlimentazione.vue?vue&type=style&index=0&id=68667edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68667edc"]])

export default __exports__